var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoCross(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100pt",
    height: "100pt",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m31.613 31.613c1.1719-1.1719 3.0703-1.1719 4.2422 0l14.141 14.141 14.141-14.141c1.1719-1.1719 3.0703-1.1719 4.2422 0s1.1719 3.0703 0 4.2422l-14.141 14.141 14.141 14.141c1.1719 1.1719 1.1719 3.0703 0 4.2422s-3.0703 1.1719-4.2422 0l-14.141-14.141-14.141 14.141c-1.1719 1.1719-3.0703 1.1719-4.2422 0s-1.1719-3.0703 0-4.2422l14.141-14.141-14.141-14.141c-1.1719-1.1719-1.1719-3.0703 0-4.2422z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCross);
export default __webpack_public_path__ + "static/media/ico-cross.09f59bfecd0697f97817af0267828968.svg";
export { ForwardRef as ReactComponent };